module.exports = __webpack_public_path__ + "img/valerio_(18mm).45b62675.jpg";